//Prime.jsx
import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import { useNavigate, useParams, Link, Navigate } from "react-router-dom";
import { FaArrowLeft, FaCheckCircle, FaTimes, FaSpinner } from "react-icons/fa";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
// ///////////////////////////////////

import { feedApi } from "../../api/feedApi";
import { commentApi } from "../../api/commentApi.js";

import api from "../../api/axios";

//// Swiper for carousel ////
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Keyboard } from "swiper/modules";
import PostSkeleton from "../../components/Post/PostSkeleton.jsx";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import { useProfile } from "../../hook/useProfile";
// import CommentModal from "../../components/components/comments/CommentModal";
import TopHeader from "../../components/comman/TopHeader";
import ProfileBadge from "../../components/comman/ProfileBadge.jsx";
import ProfileBadeg from "../../assets/images/badge/Bhagwadhar.png";
import Sidebar from "../../components/comman/Sidebar";
// import ShareModal from "../../components/share/ShareModal";
import RevolutionDetailsCard from "../../components/ui/RevolutionDetailsCard/RevolutionDetailsCard";
import PostYoutubeVideo from "../../components/Post/PostYoutubeVideo";

// import ReportModal from "../../components/report/ReportModal.jsx";
import Popup from "../../components/model/Popup.jsx";
import { useReport } from "../../hook/useReport.jsx";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

// CSS For PrimeFeed
import "../../css/User/Prime.css";
import {
  saveToken,
  saveUserId,
  getCurrentUserId,
  getCurrentUserRole,
  logout,
  isLoggedIn,
  getToken,
} from "../../utils/auth";

//// Import Font Awesome ////
// For Solid Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faBell,
  faCommentDots,
  faStar,
  faUsers,
  faUserGroup,
  faVideo,
  faBookmark,
  faUser,
  faHear,
  faCirclePlay,
  faCog,
  faHeart,
  faComments,
  faShare,
  faHashtag,
  faImage,
  faPhotoVideo,
  faLocation,
  faEllipsis,
  faLocationDot,
  faTrashCan,
  faEnvelope,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";

// FOR REGULAR ICONS (bordered / outline)
import {
  faBookmark as faBookmarkRegular,
  faHeart as faHeartRegular,
  faCirclePlay as faCirclePlayRegular,
} from "@fortawesome/free-regular-svg-icons";
//// Import Font Awesome ////

// ===== Import Iconify for icons ===== //
import { Icon } from "@iconify/react";
import { profileApi } from "../../api/profileApi.js";
// ===== Import Iconify for icons End ===== //

import userProfile from "../../assets/images/profile/userProfile.png"; // adjust path if needed

// ===== COMPONENTS ===== //
const PostCard = lazy(() => import("../../components/Post/PostCard"));
const CommentModal = lazy(
  () => import("../../components/commentCompo/comments/CommentModal"),
);
const ShareModal = lazy(() => import("../../components/share/ShareModal"));
const ReportModal = lazy(() => import("../../components/report/ReportModal"));

// Import ReactPlayer
// import ReactPlayer from "react-player";

// API BASE URL
const BASE_URL = process.env.REACT_APP_BASE_URL;

// LiveChannelCard component - displays the first live video from each channel
const LiveChannelCard = ({ channel }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const iframeRef = useRef(null);
  const containerRef = useRef(null);

  const firstLiveVideo = channel.liveVideos && channel.liveVideos[0];

  // ✅ Auto pause when scrolled out of view
  useEffect(() => {
    if (!isLoaded) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            // Scrolled out of view — pause by reloading src without autoplay
            if (iframeRef.current) {
              iframeRef.current.src = iframeRef.current.src.replace(
                "&autoplay=1",
                "&autoplay=0",
              );
            }
          }
        });
      },
      { threshold: 0.3 }, // pause when less than 30% visible
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [isLoaded]);

  if (!firstLiveVideo || hasError) return null;

  const embedUrl = `https://www.youtube.com/embed/${firstLiveVideo.videoId}?enablejsapi=1&rel=0&modestbranding=1`;

  // ✅ Stop all other iframes before playing this one
  const handlePlay = () => {
    // Pause all other live channel iframes
    const allIframes = document.querySelectorAll(".live-channel-iframe");
    allIframes.forEach((iframe) => {
      if (iframe !== iframeRef.current) {
        // Remove autoplay from other iframes to stop them
        const currentSrc = iframe.src;
        iframe.src = currentSrc
          .replace("&autoplay=1", "&autoplay=0")
          .replace("autoplay=1&", "autoplay=0&");
      }
    });

    setIsLoaded(true);
  };

  return (
    <div
      ref={containerRef}
      className="youtube-wrapper my-3"
      style={{ borderRadius: "8px", overflow: "hidden" }}
    >
      {/* Thumbnail click-to-load */}
      {!isLoaded ? (
        <div
          style={{
            position: "relative",
            cursor: "pointer",
            background: "#000",
          }}
          onClick={handlePlay} // ✅ use handlePlay instead of setIsLoaded(true)
        >
          <img
            src={
              firstLiveVideo.thumbnail ||
              `https://img.youtube.com/vi/${firstLiveVideo.videoId}/hqdefault.jpg`
            }
            alt={firstLiveVideo.title}
            style={{
              width: "100%",
              height: "315px",
              objectFit: "cover",
              display: "block",
              opacity: 0.85,
            }}
            onError={(e) => {
              e.target.src = `https://img.youtube.com/vi/${firstLiveVideo.videoId}/hqdefault.jpg`;
            }}
          />

          {/* Play button overlay */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "68px",
              height: "48px",
              background: "red",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: 0,
                height: 0,
                borderTop: "12px solid transparent",
                borderBottom: "12px solid transparent",
                borderLeft: "20px solid white",
                marginLeft: "4px",
              }}
            />
          </div>

          {/* Live badge on thumbnail */}
          <div
            style={{
              position: "absolute",
              top: "10px",
              left: "10px",
              background: "red",
              color: "white",
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            🔴 LIVE
          </div>
        </div>
      ) : (
        <iframe
          ref={iframeRef} // ✅ ref for controlling this iframe
          className="live-channel-iframe" // ✅ class for selecting all iframes
          width="100%"
          height="315"
          src={`${embedUrl}&autoplay=1`}
          title={firstLiveVideo.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{ display: "block" }}
        />
      )}

      {/* Info row */}
      <div
        className="d-flex align-items-center gap-2 mt-2 px-1"
        style={{ flexWrap: "nowrap", overflow: "hidden" }}
      >
        {isLoaded && <span className="badge bg-danger">🔴 LIVE</span>}
        <strong style={{ whiteSpace: "nowrap" }}>{channel.title}</strong>
        <small
          className="text-muted"
          style={{
            fontSize: "12px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {firstLiveVideo.title}
        </small>
      </div>
    </div>
  );
};

function Feed() {
  // use reffs
  const loadMoreRef = useRef(null);
  const feedScrollRef = useRef(null);

  // user id
  const currentUserId = getCurrentUserId(); // replace with real user id later

  // link for user profile
  const profileLink = `/my/${currentUserId}/profile`;

  const { isProfileInfo } = useProfile();
  const isCheckBatch = isProfileInfo?.isBatch;

  // console.log("Full Profile Info:", JSON.stringify(isProfileInfo));

  // for navigation
  const navigate = useNavigate();
  ////////////////////////////////////

  //===== refs for post form file inputs =====//
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  //===== refs for post form file inputs End =====//

  // ref for active video
  const activeVideoRef = useRef(null);

  // refs for video elements in feed
  const videoRefs = useRef(new Map());

  // State for live channels
  const [liveChannels, setLiveChannels] = useState([]);

  // State for sorted channels by priority
  const [sortedChannels, setSortedChannels] = useState([]);

  const [flattenedChannels, setFlattenedChannels] = useState([]);

  const isPrimeUser = isProfileInfo?.role === "PRIME";

  // Fetch live channels
  useEffect(() => {
    const fetchLiveChannels = async () => {
      try {
        const res = await api.get("api/live-channels");

        if (res.data?.data && res.data.data.length > 0) {
          setLiveChannels(res.data.data);

          // Sort channels by priority
          const sorted = [...res.data.data].sort(
            (a, b) => a.priority - b.priority,
          );
          setSortedChannels(sorted);

          // ✅ Flatten all liveVideos from all channels into one list
          const flattened = [];
          sorted.forEach((channel) => {
            if (channel.liveVideos && channel.liveVideos.length > 0) {
              channel.liveVideos.forEach((video) => {
                flattened.push({
                  ...channel, // keep channel info (title, priority etc.)
                  liveVideos: [video], // only 1 video per card
                });
              });
            }
          });

          setFlattenedChannels(flattened);
          console.log("Total flattened channel cards:", flattened.length); // should now show 16
        }
      } catch (err) {
        console.error("Live channels error", err);
      }
    };
    fetchLiveChannels();
  }, []);

  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////
  // post report
  const report = useReport({
    onReported: (target) => {
      const postId = target.id;

      const updatePosts = (posts) =>
        posts.map((p) => {
          if (p.post?._id !== postId) return p;

          return {
            ...p,
            post: {
              ...p.post,
              isReported: true,
            },
          };
        });

      if (feedType === "prime") {
        setForYouPosts((prev) => updatePosts(prev));
      }

      if (feedType === "public") {
        setPublicPosts((prev) => updatePosts(prev));
      }
    },
  });

  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////
  // State for comment delete start
  const [activeMenuId, setActiveMenuId] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [monetizeLimits, setMonetizeLimits] = useState(null);
  const [isMonetizeDisabled, setIsMonetizeDisabled] = useState(false);

  // NEW 👇
  const [deleteType, setDeleteType] = useState(null); // "comment" | "reply"
  const [parentCommentId, setParentCommentId] = useState(null);

  // If you show total comments anywhere
  const [postCommentsCount, setPostCommentsCount] = useState(0);

  const handleDeleteComment = async () => {
    try {
      await commentApi.deleteComment(deleteTargetId);

      // ===== DELETE MAIN COMMENT =====
      if (deleteType === "comment") {
        setComments((prev) => prev.filter((c) => c._id !== deleteTargetId));

        // UNIVERSAL COMMENT COUNT DECREASE
        const decreaseCommentCount = (posts = []) =>
          posts.map((item) => {
            // Root level post
            if (item._id === activePost) {
              return {
                ...item,
                commentsCount: Math.max((item.commentsCount || 1) - 1, 0),
              };
            }

            // Nested post (public or repost)
            if (item.post?._id === activePost) {
              return {
                ...item,
                post: {
                  ...item.post,
                  commentsCount: Math.max(
                    (item.post.commentsCount || 1) - 1,
                    0,
                  ),
                },
              };
            }

            return item;
          });

        // PUBLIC
        if (feedType === "public") {
          setPublicPosts((prev) => decreaseCommentCount(prev));
        }

        // PRIME
        if (feedType === "prime") {
          setForYouPosts((prev) => decreaseCommentCount(prev));
          setNationalPosts((prev) => decreaseCommentCount(prev));
          setStatePosts((prev) => decreaseCommentCount(prev));
          setDistrictPosts((prev) => decreaseCommentCount(prev));
        }
      }

      // ===== DELETE REPLY =====
      if (deleteType === "reply") {
        setRepliesMap((prev) => ({
          ...prev,
          [parentCommentId]:
            prev[parentCommentId]?.filter((r) => r._id !== deleteTargetId) ||
            [],
        }));

        setComments((prev) =>
          prev.map((c) =>
            c._id === parentCommentId
              ? {
                  ...c,
                  repliesCount: Math.max((c.repliesCount || 1) - 1, 0),
                }
              : c,
          ),
        );
      }

      toast.success("Deleted successfully");
    } catch (err) {
      toast.error("Failed to delete");
    } finally {
      setShowDeleteConfirm(false);
      setDeleteTargetId(null);
      setDeleteType(null);
      setParentCommentId(null);
    }
  };
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);

  // for posts feed data
  // get feed type param from url
  const { type } = useParams();

  // For revolution data
  // For prime post data
  const [forYouPosts, setForYouPosts] = useState([]);

  // For public posts data
  const [publicPosts, setPublicPosts] = useState([]);

  // pagination for public feed - UPDATED FOR CURSOR
  const [publicCursor, setPublicCursor] = useState(null);
  const [hasMorePublic, setHasMorePublic] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const PUBLIC_LIMIT = 10;

  // PRIME pagination - UPDATED FOR CURSOR
  const [primeCursor, setPrimeCursor] = useState(null);
  const [hasMorePrime, setHasMorePrime] = useState(true);
  const [loadingPrimeMore, setLoadingPrimeMore] = useState(false);
  const PRIME_LIMIT = 10;

  // NATIONAL TAB pagination - CURSOR BASED
  const [nationalPosts, setNationalPosts] = useState([]);
  const [nationalCursor, setNationalCursor] = useState(null);
  const [hasMoreNational, setHasMoreNational] = useState(true);
  const [loadingNational, setLoadingNational] = useState(false);
  const NATIONAL_LIMIT = 10;

  // STATE TAB pagination - CURSOR BASED
  const [statePosts, setStatePosts] = useState([]);
  const [stateCursor, setStateCursor] = useState(null);
  const [hasMoreState, setHasMoreState] = useState(true);
  const [loadingState, setLoadingState] = useState(false);
  const STATE_LIMIT = 10;

  // DISTRICT TAB pagination - CURSOR BASED
  const [districtPosts, setDistrictPosts] = useState([]);
  const [districtCursor, setDistrictCursor] = useState(null);
  const [hasMoreDistrict, setHasMoreDistrict] = useState(true);
  const [loadingDistrict, setLoadingDistrict] = useState(false);
  const DISTRICT_LIMIT = 10;

  // for loading and error states
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // for image modal
  const [showImageModal, setShowImageModal] = useState(false);
  const [activeImages, setActiveImages] = useState([]);

  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  // SHARE FUNCTIONALITY
  const [sharePost, setSharePost] = useState(null);

  // Open share modal
  const handleShareClick = (post) => {
    // console.log("Setting sharePost:", JSON.stringify(post, null, 2));
    setSharePost(post);
  };

  // External share handler
  const handleInternalShare = (post) => {
    console.log("Internal share:", post._id);
    // open chat/user selection modal
    setSharePost(null);
  };

  // External share handler
  const handleExternalShare = async (post) => {
    // const shareUrl = `${window.location.origin}/post/${post._id}`;
    const shareUrl =
      post?.feedType === "REVOLUTION"
        ? `${window.location.origin}/r/${post._id}`
        : `${window.location.origin}/post/${post._id}`;

    if (navigator.share) {
      await navigator.share({
        title: "Check this post",
        url: shareUrl,
      });
    } else {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    }

    setSharePost(null);
  };

  // Handle Repost
  const handleRepost = async (post, description) => {
    console.log(post, "jshjgghsdcgsvh");
    try {
      const res = await api.post(`/feeds/${post._id}/repost`, {
        description: description,
      });

      const repostedPost = res.data.repost;

      toast.success("Post reposted.");
    } catch (err) {
      const errorMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Something went wrong";
      toast.error(errorMsg);
    } finally {
      setSharePost(null);
    }
  };

  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////

  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  // States fo revolution details
  const { id } = useParams();
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);
  const [signatureSubmitted, setSignatureSubmitted] = useState(false);
  const [supportStatus, setSupportStatus] = useState({});
  const [revolutionData, setRevolutionData] = useState([]);
  const [commentInput, setCommentInput] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [signatureData, setSignatureData] = useState(null);
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////

  // for top tabs functionality (foryou, national, state, destrict)
  // const [activeTab, setActiveTab] = useState("forYou");
  const [activeTab, setActiveTab] = useState("PUBLIC");
  // or "PRIME", "REVOLUTION"

  ////////////////////////////////////////////////////////////////
  // allowed feed types
  const allowedTypes = ["prime", "public"];

  // set feed type
  const [feedType, setFeedType] = useState(type);

  useEffect(() => {
    if (type === "public" || type === "prime") {
      setFeedType(type);
    }
  }, [type]);

  // RESET PRIME PUBLIC PAGINATION WHEN FEED CHANGES
  useEffect(() => {
    if (feedType === "prime") {
      setActiveSidebar("prime");
      setActiveTab("forYou");

      // RESET prime pagination for all tabs
      setForYouPosts([]);
      setPrimeCursor(null);
      setHasMorePrime(true);

      setNationalPosts([]);
      setNationalCursor(null);
      setHasMoreNational(true);

      setStatePosts([]);
      setStateCursor(null);
      setHasMoreState(true);

      setDistrictPosts([]);
      setDistrictCursor(null);
      setHasMoreDistrict(true);

      fetchPrimePosts(null, false);
    }

    if (feedType === "public") {
      setActiveSidebar("public");
      setActiveTab("forYou");

      setPublicPosts([]);
      setPublicCursor(null);
      setHasMorePublic(true);

      fetchPublicPosts(null, false);
    }
  }, [feedType]);

  // SCROLL HANDLER FOR BOTH FEEDS
  useEffect(() => {
    const container = feedScrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (scrollTop + clientHeight < scrollHeight - 20) return;

      // PUBLIC FEED
      if (
        feedType === "public" &&
        hasMorePublic &&
        !loading &&
        !loadingMore &&
        publicCursor
      ) {
        fetchPublicPosts(publicCursor, true);
      }

      // PRIME FEED - FOR YOU TAB
      if (
        feedType === "prime" &&
        activeTab === "forYou" &&
        hasMorePrime &&
        !loading &&
        !loadingPrimeMore &&
        primeCursor
      ) {
        fetchPrimePosts(primeCursor, true);
      }

      // PRIME FEED - NATIONAL TAB
      if (
        feedType === "prime" &&
        activeTab === "national" &&
        hasMoreNational &&
        !loadingNational &&
        nationalCursor
      ) {
        fetchNationalPosts(nationalCursor, true);
      }

      // PRIME FEED - STATE TAB
      if (
        feedType === "prime" &&
        activeTab === "state" &&
        hasMoreState &&
        !loadingState &&
        stateCursor
      ) {
        fetchStatePosts(stateCursor, true);
      }

      // PRIME FEED - DISTRICT TAB
      if (
        feedType === "prime" &&
        activeTab === "district" &&
        hasMoreDistrict &&
        !loadingDistrict &&
        districtCursor
      ) {
        fetchDistrictPosts(districtCursor, true);
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [
    feedType,
    activeTab,
    publicCursor,
    primeCursor,
    nationalCursor,
    stateCursor,
    districtCursor,
    hasMorePublic,
    hasMorePrime,
    hasMoreNational,
    hasMoreState,
    hasMoreDistrict,
    loading,
    loadingMore,
    loadingPrimeMore,
    loadingNational,
    loadingState,
    loadingDistrict,
  ]);

  /////////////////////////////////////////////////////
  // for helper function API Call
  const publicControllerRef = useRef(null);
  const primeControllerRef = useRef(null);
  const nationalControllerRef = useRef(null);
  const stateControllerRef = useRef(null);
  const districtControllerRef = useRef(null);

  // function to fetch prime posts with cursor pagination
  const fetchPrimePosts = async (cursor = null, isLoadMore = false) => {
    if (!isLoadMore && !hasMorePrime) return;

    // Show loading states
    !isLoadMore ? setLoading(true) : setLoadingPrimeMore(true);

    try {
      const data = await feedApi.getFeed({
        type: "PRIME",
        limit: PRIME_LIMIT,
        cursor: cursor,
      });

      const newPosts = data.posts || [];
      const newRevolutions = data.revolutions || [];
      const nextCursor = data.nextCursor || null;

      // Set revolutions only once (TOP)
      if (!isLoadMore && newRevolutions.length) {
        setRevolutionData(newRevolutions);
      }

      // Update feed state
      setForYouPosts((prev) =>
        isLoadMore ? [...prev, ...newPosts] : newPosts,
      );

      // Update cursor and hasMore flag
      setPrimeCursor(nextCursor);
      setHasMorePrime(!!nextCursor && newPosts.length > 0);
    } catch (err) {
      if (err.name !== "CanceledError") {
        console.error("Prime API Error:", err);
        setHasMorePrime(false);
      }
    } finally {
      setLoading(false);
      setLoadingPrimeMore(false);
    }
  };

  // function to fetch national posts with cursor pagination
  const fetchNationalPosts = async (cursor = null, isLoadMore = false) => {
    if (!isLoadMore && !hasMoreNational) return;

    setLoadingNational(true);

    try {
      const data = await feedApi.getNationalPost({
        limit: NATIONAL_LIMIT,
        cursor: cursor,
      });

      const newPosts = data.posts || [];
      const nextCursor = data.nextCursor || null;

      setNationalPosts((prev) =>
        isLoadMore ? [...prev, ...newPosts] : newPosts,
      );

      setNationalCursor(nextCursor);
      setHasMoreNational(!!nextCursor && newPosts.length > 0);
    } catch (err) {
      if (err.name !== "CanceledError") {
        console.error("National API Error:", err);
        setHasMoreNational(false);
      }
    } finally {
      setLoadingNational(false);
    }
  };

  // function to fetch state posts with cursor pagination
  const fetchStatePosts = async (cursor = null, isLoadMore = false) => {
    if (!isLoadMore && !hasMoreState) return;

    setLoadingState(true);

    try {
      const data = await feedApi.getStatePost({
        limit: STATE_LIMIT,
        cursor: cursor,
      });

      const newPosts = data.posts || [];
      const nextCursor = data.nextCursor || null;

      setStatePosts((prev) => (isLoadMore ? [...prev, ...newPosts] : newPosts));

      setStateCursor(nextCursor);
      setHasMoreState(!!nextCursor && newPosts.length > 0);
    } catch (err) {
      if (err.name !== "CanceledError") {
        console.error("State API Error:", err);
        setHasMoreState(false);
      }
    } finally {
      setLoadingState(false);
    }
  };

  // function to fetch district posts with cursor pagination
  const fetchDistrictPosts = async (cursor = null, isLoadMore = false) => {
    if (!isLoadMore && !hasMoreDistrict) return;

    setLoadingDistrict(true);

    try {
      const data = await feedApi.getDistrictPost({
        limit: DISTRICT_LIMIT,
        cursor: cursor,
      });

      const newPosts = data.posts || [];
      const nextCursor = data.nextCursor || null;

      setDistrictPosts((prev) =>
        isLoadMore ? [...prev, ...newPosts] : newPosts,
      );

      setDistrictCursor(nextCursor);
      setHasMoreDistrict(!!nextCursor && newPosts.length > 0);
    } catch (err) {
      if (err.name !== "CanceledError") {
        console.error("District API Error:", err);
        setHasMoreDistrict(false);
      }
    } finally {
      setLoadingDistrict(false);
    }
  };

  // function to fetch public posts with cursor pagination
  const fetchPublicPosts = async (cursor = null, isLoadMore = false) => {
    if (!isLoadMore && !hasMorePublic) return;

    !isLoadMore ? setLoading(true) : setLoadingMore(true);

    try {
      const data = await feedApi.getFeed({
        type: "PUBLIC",
        limit: PUBLIC_LIMIT,
        cursor: cursor,
      });

      const newPosts = data.posts || [];
      const nextCursor = data.nextCursor || null;

      // Update feed state
      setPublicPosts((prev) =>
        isLoadMore ? [...prev, ...newPosts] : newPosts,
      );

      // Update cursor and hasMore flag
      setPublicCursor(nextCursor);
      setHasMorePublic(!!nextCursor && newPosts.length > 0);
    } catch (err) {
      if (err.name !== "CanceledError") {
        console.error(err);
        setHasMorePublic(false);
      }
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  // Video Play Pouse When Previous and then start Second Then Auto pouse previous
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            // Pause previously playing video
            if (activeVideoRef.current && activeVideoRef.current !== video) {
              activeVideoRef.current.pause();
            }
          } else {
            video.pause();

            if (activeVideoRef.current === video) {
              activeVideoRef.current = null;
            }
          }
        });
      },
      { threshold: 0.5 },
    );

    videoRefs.current.forEach((video) => {
      observer.observe(video);
    });

    return () => {
      videoRefs.current.forEach((video) => {
        observer.unobserve(video);
      });
      observer.disconnect();
    };
  }, [publicPosts]);

  // Active media reference for controlling playback
  const activeMediaRef = useRef({
    type: null,
    el: null,
  });

  // handle video play to pause other videos
  const handleVideoPlay = (videoEl) => {
    if (activeMediaRef.current.el) {
      if (activeMediaRef.current.el !== videoEl) {
        activeMediaRef.current.el.pause();
      }
    }

    activeMediaRef.current = { type: "video", el: videoEl };
  };

  const handleVideoPlay2 = (videoEl) => {
    if (activeMediaRef.current.el && activeMediaRef.current.el !== videoEl) {
      activeMediaRef.current.el.pause();
    }
    activeMediaRef.current = { type: "video", el: videoEl };
  };
  /////////////////////////

  // post skeleton component
  const PostSkeleton = () => {
    return (
      <div className=" feed-post-card skeleton">
        {/* Header */}
        <div className="post-header-container d-flex align-items-center">
          <div className="skeleton-avatar"></div>
          <div className="skeleton-header-text">
            <div className="skeleton-line short"></div>
            <div className="skeleton-line xsmall"></div>
          </div>
        </div>

        {/* Text */}
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>

        {/* Image */}
        <div className="skeleton-image"></div>

        {/* Footer */}
        <div className="skeleton-footer">
          <div className="skeleton-icon"></div>
          <div className="skeleton-icon"></div>
          <div className="skeleton-icon"></div>
        </div>
      </div>
    );
  };

  //===== for left sidebar buttons =====//
  const [activeSidebar, setActiveSidebar] = useState("prime");

  // SIDEBAR MENU
  const sidebarMenus = getSidebarMenus(currentUserId);

  //===== left sidebar buttons end =====//

  // for trending toogle
  const [showMoreTrends, setShowMoreTrends] = useState(false);

  // for menu toggle functionality
  const [showSidebar, setShowSidebar] = useState(true);

  //======================= for prime public feed post form functionality start =======================//
  // post text state
  const [postText, setPostText] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  // for monetization
  const [isMonetized, setIsMonetized] = useState(false);
  const [disableUntil, setDisableUntil] = useState(null);

  // for video selection in post form
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoType, setVideoType] = useState(""); // "short" | "long"

  // for image selection
  const handleImageSelect = (e) => {
    if (selectedVideo) {
      alert("You cannot upload images when a video is selected");
      imageInputRef.current.value = "";
      return;
    }

    const files = Array.from(e.target.files);

    const imageFiles = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setSelectedImages((prev) => [...prev, ...imageFiles]);
  };

  // for removing selected image
  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));

    // reset input so same image can be selected again
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
  };

  // for video selection
  const handleVideoSelect = (e) => {
    if (selectedImages.length > 0) {
      alert("You cannot upload a video when images are selected");
      videoInputRef.current.value = "";
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(video.src);

      const duration = video.duration;
      setVideoType(duration <= 60 ? "short" : "long");

      setSelectedVideo({
        file,
        preview: URL.createObjectURL(file),
        duration,
      });
    };

    video.src = URL.createObjectURL(file);
  };

  // for removing selected video
  const removeVideo = () => {
    setSelectedVideo(null);
    setVideoType("");

    if (videoInputRef.current) {
      videoInputRef.current.value = "";
    }
  };

  //========== for public feed post submission ==============//
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  // Create Post Form Reset Function
  const resetPostForm = () => {
    setPostText("");
    setSelectedImages([]);
    setSelectedVideo(null);
    setVideoType("");
    setIsMonetized(false);

    if (imageInputRef.current) imageInputRef.current.value = "";
    if (videoInputRef.current) videoInputRef.current.value = "";
  };

  // ============= DESABLE MONETIZATION BUTTON FOR 24  HOURS START ============= //
  useEffect(() => {
    const savedTimestamp = localStorage.getItem("lastMonetizedPostTime");
    if (savedTimestamp) {
      setDisableUntil(new Date(savedTimestamp));
    }
  }, []);

  const [showPopup, setShowPopup] = useState(false);

  // ======= FETCH POST LIMIT FOR MONETIZED POST START ======= //
  const [monetizePostLimit, setMonetizePostLimit] = useState(false);

  // ======= FETCH POST LIMIT FOR MONETIZED POST END ======= //
  const handleMonetizeClick = (e) => {
    // If monetization lavel low
    if (isProfileInfo?.monetizationLevel < 2) {
      e.preventDefault();
      toast.warning("Your monetization level is too low");
      return;
    }

    // If daily limit reached
    if (isMonetizeDisabled) {
      e.preventDefault();
      toast.warning(
        `Daily monetize post limit reached (Max ${monetizePostLimit})`,
      );
      return;
    }
  };

  // ========== HANDLE MONETOZED BUTTON DISABLE START ========== //
  const checkMonetizeDisable = async () => {
    try {
      //  Get limit from backend
      const data = await feedApi.getMonetizedPostLimits();

      if (!data?.success) return;

      const monetizedPostLimit = data?.monetizedPostLimit || 0;
      setMonetizePostLimit(monetizedPostLimit || 0);
      const res = await feedApi.monetizedPostsCount();

      const monetizedCount = res.monetizedPostCount || 0;

      // Disable checkbox when limit reached
      setIsMonetizeDisabled(monetizedCount >= monetizedPostLimit);
    } catch (error) {
      toast.error("Something went wrong.");
    }
  };

  useEffect(() => {
    checkMonetizeDisable();
  }, []);

// ========== HANDLE MONETIZE TOGGLE (fresh check at toggle time) ========== //
// Runs the limit check the moment the user tries to turn the switch ON,
// instead of only finding out after the post is created.
const handleMonetizeToggle = async (checked) => {
  // Turning OFF is always allowed
  if (!checked) {
    setIsMonetized(false);
    return;
  }

  // Must be monetization level 2+
  if (Number(isProfileInfo?.monetizationLevel) < 2) {
    toast.warning("Upgrade to level 2 to enable monetization");
    setIsMonetized(false);
    return;
  }

  // Fetch the latest limit/count fresh, right at toggle time
  try {
    const limitData = await feedApi.getMonetizedPostLimits();
    const limit = limitData?.monetizedPostLimit || 0;
    setMonetizePostLimit(limit);

    const countRes = await feedApi.monetizedPostsCount();
    const monetizedCount = countRes?.monetizedPostCount || 0;

    const limitReached = monetizedCount >= limit;
    setIsMonetizeDisabled(limitReached);

    if (limitReached) {
      toast.warning(`Daily monetize post limit reached (Max ${limit})`);
      setIsMonetized(false);
      return;
    }

    setIsMonetized(true);
  } catch (error) {
    toast.error("Something went wrong.");
    setIsMonetized(false);
  }
};

  // Handle Post Submition by Helper Function For Both Feed Prime and Public
  const handlePostSubmit = async ({ postFeedType }) => {
    if (selectedImages.length > 5) {
      toast.warning("You can upload maximum 5 images per post");
      return;
    }

    if (!postText && selectedImages.length === 0 && !selectedVideo) {
      toast.warning("Post cannot be empty");
      return;
    }

    try {
      setIsUploading(true);
      setUploadProgress(0);

      console.log("isMonetized", isMonetized);
      const data = await feedApi.createPost({
        description: postText,
        feedType: postFeedType,
        images: selectedImages,
        video: selectedVideo,
        isMonetized: isMonetized,

        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );

          setUploadProgress(percent);
        },
      });

      const newPost = data.post;
      setUploadProgress(100);

      await checkMonetizeDisable();

      // ADD NEW POST ON TOP
      if (postFeedType === "PRIME") {
        setForYouPosts((prev) => [newPost, ...prev]);
      } else {
        if (isProfileInfo?.adhaarVerified === "NONE") {
          setShowPopup(true);
        } else {
          setShowPopup(false);
        }
        setPublicPosts((prev) => [
          {
            type: "POST",
            post: newPost,
          },
          ...prev,
        ]);
      }

      // RESET FORM
      resetPostForm();
    } catch (error) {
      if (error.response) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response.data.error || "Something went wrong",
          confirmButtonColor: "#e74c3c",
        });
      } else {
        toast.error("Network error. Please try again.");
      }
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };
  //======================= for prime public feed post form functionality end =======================//

  //======================= for public feed follow and unfollow start =======================//
  const [followLoading, setFollowLoading] = useState({});

  const handleFollowToggle = async (post) => {
    const userId = post?.user?._id;

    if (!userId) return;

    const updatePosts = (posts = []) =>
      posts.map((item) => {
        let updatedItem = { ...item };

        // ===== CASE 1: ORIGINAL POST USER =====
        if (item.post?.user?._id === userId) {
          updatedItem.post = {
            ...item.post,
            isFollowing: !item.post.isFollowing,
          };
        }

        // ===== CASE 2: NORMAL POST STRUCTURE =====
        if (item.user?._id === userId) {
          updatedItem = {
            ...item,
            isFollowing: !item.isFollowing,
          };
        }

        // ===== CASE 3: REPOSTED BY USER =====
        if (item.repostedBy?._id === userId) {
          updatedItem.repostedBy = {
            ...item.repostedBy,
            isFollowing: !item?.repostedBy?.isFollowing,
          };
        }

        return updatedItem;
      });

    // Update public feed
    setPublicPosts((prev) => updatePosts(prev));

    try {
      const isCurrentlyFollowing = post?.user?.isFollowing || post?.isFollowing;

      if (isCurrentlyFollowing) {
        await feedApi.unfollowUser({ userId });
      } else {
        await feedApi.followUser({ userId });
      }
    } catch (err) {
      console.error("Follow failed", err);
    }
  };

  //======================= for public feed follow and unfollow end =======================//

  //======================= for prime feed bookmark, like functionality =======================//
  const handleLikeToggle = async (postId) => {
    const updatePosts = (posts) =>
      posts.map((item) => {
        // ===== CASE 1: Root level post =====
        if (item._id === postId) {
          return {
            ...item,
            isLiked: !item.isLiked,
            likesCount: item.isLiked
              ? item.likesCount - 1
              : item.likesCount + 1,
          };
        }

        // ===== CASE 2: Nested post (public normal OR repost) =====
        if (item.post?._id === postId) {
          return {
            ...item,
            post: {
              ...item.post,
              isLiked: !item.post.isLiked,
              likesCount: item.post.isLiked
                ? item.post.likesCount - 1
                : item.post.likesCount + 1,
            },
          };
        }

        return item;
      });

    // PUBLIC
    if (feedType === "public") {
      setPublicPosts((prev) => updatePosts(prev));
    }

    // PRIME (update ALL prime tabs)
    if (feedType === "prime") {
      setForYouPosts((prev) => updatePosts(prev));
      setNationalPosts((prev) => updatePosts(prev));
      setStatePosts((prev) => updatePosts(prev));
      setDistrictPosts((prev) => updatePosts(prev));
    }

    // API CALL
    try {
      await feedApi.toggleLike({ postId });
    } catch (error) {
      console.error("Like failed", error);
    }
  };

  // for save toggle
  const handleSaveToggle = async (postId) => {
    const updatePosts = (posts = []) =>
      posts.map((item) => {
        // ===== PUBLIC (nested structure) =====
        if (item.post?._id === postId) {
          return {
            ...item,
            post: {
              ...item.post,
              isSaved: !item.post.isSaved,
            },
          };
        }

        // ===== PRIME (flat structure) =====
        if (item._id === postId) {
          return {
            ...item,
            isSaved: !item.isSaved,
          };
        }

        return item;
      });

    // Store the previous saved state to check if we're saving or unsaving
    let isCurrentlySaved = false;
    
    // Check current state before updating
    if (feedType === "public") {
      const post = publicPosts.find(item => item.post?._id === postId);
      isCurrentlySaved = post?.post?.isSaved || false;
    } else if (feedType === "prime") {
      const post = forYouPosts.find(item => item._id === postId);
      isCurrentlySaved = post?.isSaved || false;
    }

    if (feedType === "public") {
      setPublicPosts((prev) => updatePosts(prev));
    }

    if (feedType === "prime") {
      setForYouPosts((prev) => updatePosts(prev));
      setNationalPosts((prev) => updatePosts(prev));
      setStatePosts((prev) => updatePosts(prev));
      setDistrictPosts((prev) => updatePosts(prev));
    }

    try {
      await feedApi.toggleSave({ postId });
      
      // Show toast message based on action (save or unsave)
      if (!isCurrentlySaved) {
        toast.success('Post Saved Successfully', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      } else {
        toast.info('Post Unsaved', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      }
    } catch (error) {
      console.error("Save failed", error);
      toast.error('Failed to save post', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  //======================= for prime feed bookmark, like functionality end =======================//

  ///////////////////////////////////////////////////////
  // for closing image modal on ESC key press
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setShowImageModal(false);
      }
    };

    if (showImageModal) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [showImageModal]);

  //======================= comment modal start =======================//
  ////////////////////////////////////////////////////////////

  // const [showCommentModal, setShowCommentModal] = useState(false);
  const [activePost, setActivePost] = useState(null);

  // SET POST OWNER ID
  const [postOwnerId, setPostOwnerId] = useState(null);

  ////////////////////////////////////////////////////////////

  // for main comments
  const [showCommentModal, setShowCommentModal] = useState(false);
  // const [activePostId, setActivePostId] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);

  // Comment pagination states
  const [commentCursor, setCommentCursor] = useState(null);
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [loadingMoreComments, setLoadingMoreComments] = useState(false);
  const [totalCommentsCount, setTotalCommentsCount] = useState(0);

  // for replying to specific comment
  const [replyText, setReplyText] = useState("");
  const [replyTo, setReplyTo] = useState(null); // commentId
  const [repliesMap, setRepliesMap] = useState({});
  const [loadingReplies, setLoadingReplies] = useState({});

  // open comment modal

  // Updated openComments function with pagination
  // Updated openComments function with pagination
// Updated openComments function with manual pagination tracking
const openComments = async (post, isLoadMore = false, cursor = null) => {
  if (!isLoadMore) {
    // First load - reset everything
    setActivePost(post._id);
    setPostOwnerId(post?.user?._id);
    setShowCommentModal(true);
    setCommentLoading(true);
    setComments([]);
    setCommentCursor(null);
    
    // Use the post's commentsCount as the total
    setTotalCommentsCount(post.commentsCount || 0);
  } else {
    // Load more
    setLoadingMoreComments(true);
  }

  try {
    const data = await feedApi.getCommentsByPost({
      postId: post._id,
      cursor: cursor || null,
      limit: 10,
    });

    let updatedComments;
    if (isLoadMore) {
      updatedComments = [...comments, ...(data.comments || [])];
      setComments(updatedComments);
    } else {
      updatedComments = data.comments || [];
      setComments(updatedComments);
    }

    setCommentCursor(data.nextCursor || null);
    
    // ✅ FIX: Manually determine if there are more comments based on total count
    const totalCount = post.commentsCount || 0;
    const loadedCount = updatedComments.length;
    const hasMore = loadedCount < totalCount;
    
    setHasMoreComments(hasMore);
  } catch (err) {
    console.error("Fetch comments failed:", err);
  } finally {
    setCommentLoading(false);
    setLoadingMoreComments(false);
  }
};

const loadMoreComments = () => {
    if (!hasMoreComments || loadingMoreComments) return;
    // Find the current post
    let currentPost = null;
    if (feedType === "public") {
      currentPost = publicPosts.find(item => item.post?._id === activePost || item._id === activePost);
    } else if (feedType === "prime") {
      currentPost = forYouPosts.find(item => item._id === activePost);
    }
    if (currentPost) {
      openComments(currentPost, true, commentCursor);
    }
  };

  const fetchReplies = async (commentId) => {
    // TOGGLE HIDE REPLIES
    if (repliesMap[commentId]) {
      setRepliesMap((prev) => {
        const copy = { ...prev };
        delete copy[commentId];
        return copy;
      });
      return;
    }

    setLoadingReplies((prev) => ({ ...prev, [commentId]: true }));

    try {
      const data = await feedApi.getRepliesByComment({
        commentId,
      });

      setRepliesMap((prev) => ({
        ...prev,
        [commentId]: data.replies || [],
      }));
    } catch (err) {
      console.error("Fetch replies failed:", err);
    } finally {
      setLoadingReplies((prev) => ({ ...prev, [commentId]: false }));
    }
  };

  // Handle add replies

  const handleAddReply = async (parentCommentId) => {
    if (!replyText.trim()) return;

    const text = replyText;
    setReplyText(""); // optimistic clear

    try {
      const data = await feedApi.addCommentReply({
        postId: activePost,
        content: text,
        parentCommentId,
      });

      if (!data.success) return;

      const newReply = {
        ...data.comment,
        user: data.comment.user || { fullName: "You" },
      };

      // UPDATE REPLIES LIST INSTANTLY
      setRepliesMap((prev) => ({
        ...prev,
        [parentCommentId]: [...(prev[parentCommentId] || []), newReply],
      }));

      // INCREMENT REPLIES COUNT ON COMMENT
      setComments((prev) =>
        prev.map((c) =>
          c._id === parentCommentId
            ? { ...c, repliesCount: c.repliesCount + 1 }
            : c,
        ),
      );

      setReplyTo(null);
    } catch (err) {
      console.error("Reply failed:", err);
    }
  };

  // For Comment input
  const [commentText, setCommentText] = useState("");
  const [isCommentSubmitting, setIsCommentSubmitting] = useState(false);

  // For comment loading simulation
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (showCommentModal) {
      setIsLoading(true);

      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [showCommentModal]);

  // comment skeleton component
  const CommentSkeleton = () => {
    return (
      <div className="comment-skeleton">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((_, i) => (
          <div className="comment-skeleton-item" key={i}>
            <div className="skeleton-avatar"></div>
            <div className="skeleton-content">
              <div className="skeleton-line short"></div>
              <div className="skeleton-line"></div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // handle comment like

  const handleCommentLike = async (commentId) => {
    // OPTIMISTIC UPDATE
    setComments((prev) =>
      prev.map((c) =>
        c._id === commentId
          ? {
              ...c,
              isLiked: !c.isLiked,
              likesCount: c.isLiked ? c.likesCount - 1 : c.likesCount + 1,
            }
          : c,
      ),
    );

    try {
      await feedApi.likeComment({ commentId });
    } catch (err) {
      console.error(err);

      // ROLLBACK ON ERROR
      setComments((prev) =>
        prev.map((c) =>
          c._id === commentId
            ? {
                ...c,
                isLiked: !c.isLiked,
                likesCount: c.isLiked ? c.likesCount - 1 : c.likesCount + 1,
              }
            : c,
        ),
      );
    }
  };

  const handleAddComment = async () => {
    if (!commentText.trim()) return;

    const text = commentText;
    setCommentText(""); // optimistic clear

    try {
      const data = await feedApi.addComment({
        postId: activePost,
        content: text,
      });

      if (!data.success) return;

      // MODAL COMMENTS UPDATE
      setComments((prev) => [data.comment, ...prev]);

      // UNIVERSAL COMMENT COUNT UPDATE
      const updateCommentCount = (posts = []) =>
        posts.map((item) => {
          // Root level post
          if (item._id === activePost) {
            return {
              ...item,
              commentsCount: (item.commentsCount || 0) + 1,
            };
          }

          // Nested post (public or repost)
          if (item.post?._id === activePost) {
            return {
              ...item,
              post: {
                ...item.post,
                commentsCount: (item.post.commentsCount || 0) + 1,
              },
            };
          }

          return item;
        });

      // PUBLIC
      if (feedType === "public") {
        setPublicPosts((prev) => updateCommentCount(prev));
      }

      // PRIME
      if (feedType === "prime") {
        setForYouPosts((prev) => updateCommentCount(prev));
        setNationalPosts((prev) => updateCommentCount(prev));
        setStatePosts((prev) => updateCommentCount(prev));
        setDistrictPosts((prev) => updateCommentCount(prev));
      }
    } catch (err) {
      console.error(err);
    }
  };
  //======================= for comment modal end =======================//

  //======================= for public post edit and delete start =======================//
  // Edit modal states for feed posts
  // Edit modal
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingPost, setEditingPost] = useState(null);

  // form fields
  const [editText, setEditText] = useState("");
  const [editImages, setEditImages] = useState([]); // [{file, preview}]
  const [editVideo, setEditVideo] = useState(null); // {file, preview, duration}
  const [editVideoType, setEditVideoType] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  // Edit modal refs for feed posts
  const editImageInputRef = useRef(null);
  const editVideoInputRef = useRef(null);

  // open edit modal
  const handleEditPost = (post) => {
    setEditingPost(post);
    setEditText(post.description || "");

    // images
    if (post.images?.length) {
      setEditImages(
        post.images.map((img) => ({
          file: null, // existing image
          preview: `${img.replace(/\\/g, "/")}`,
        })),
      );
      setEditVideo(null);
      setEditVideoType("");
    }

    // video
    if (post.video) {
      setEditVideo({
        file: null,
        preview: `${post.video.replace(/\\/g, "/")}`,
        duration: post.videoDuration || 0,
      });
      setEditVideoType(post.videoDuration <= 60 ? "short" : "long");
      setEditImages([]);
    }

    setShowEditModal(true);
  };

  // handle edit image selection
  const handleEditImageSelect = (e) => {
    if (editVideo) {
      alert("Remove video to add images");
      e.target.value = "";
      return;
    }

    const files = Array.from(e.target.files);
    if (!files.length) return;

    if (files.length > 10) {
      alert("Max 10 images");
      e.target.value = "";
      return;
    }

    const imgs = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    // REPLACE old images
    setEditImages(imgs);

    // allow reselect later
    e.target.value = "";
  };

  // handle remove edit image
  const handleRemoveEditImage = (index) => {
    setEditImages((prev) => prev.filter((_, i) => i !== index));

    // reset file input so same image can be reselected
    if (editImageInputRef.current) {
      editImageInputRef.current.value = "";
    }
  };

  // handle edit video selection
  const handleEditVideoSelect = (e) => {
    if (editImages.length > 0) {
      alert("Remove images to add video");
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      setEditVideo({
        file,
        preview: URL.createObjectURL(file),
        duration: video.duration,
      });
      setEditVideoType(video.duration <= 60 ? "short" : "long");
    };

    video.src = URL.createObjectURL(file);
  };

  // handle remove edit video
  const handleRemoveEditVideo = () => {
    setEditVideo(null);
    setEditVideoType("");
  };

  // Handle update post

  const handleUpdatePost = async () => {
    if (!editingPost) return;

    if (editImages.length > 5) {
      toast.warning("You can upload maximum 5 images per post");
      return;
    }

    setIsUpdating(true);

    try {
      const data = await feedApi.updatePost({
        postId: editingPost._id,
        description: editText,
        images: editImages,
        video: editVideo,
      });

      const updatedPost = data.post;

      // UPDATE PUBLIC FEED INSTANTLY
      if (feedType === "public") {
        setPublicPosts((prev) =>
          prev.map((item) =>
            item.post?._id === updatedPost._id
              ? {
                  ...item,
                  post: { ...item.post, ...updatedPost },
                }
              : item,
          ),
        );
      }

      // UPDATE PRIME FEED INSTANTLY
      if (feedType === "prime") {
        setForYouPosts((prev) =>
          prev.map((post) =>
            post._id === updatedPost._id ? { ...post, ...updatedPost } : post,
          ),
        );

        setNationalPosts((prev) =>
          prev.map((post) =>
            post._id === updatedPost._id ? { ...post, ...updatedPost } : post,
          ),
        );

        setStatePosts((prev) =>
          prev.map((post) =>
            post._id === updatedPost._id ? { ...post, ...updatedPost } : post,
          ),
        );

        setDistrictPosts((prev) =>
          prev.map((post) =>
            post._id === updatedPost._id ? { ...post, ...updatedPost } : post,
          ),
        );
      }

      setShowEditModal(false);
      setEditingPost(null);
    } catch (err) {
      console.error("Edit failed", err);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDeletePost = async (postId) => {
    // ===== CONFIRMTION ALERT =====
    const result = await Swal.fire({
      title: "Delete this post?",
      text: "This action cannot be undone",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
    });

    if (!result.isConfirmed) return;

    // ===== STORE PREVIOUS STATE =====
    let prevPublicPosts,
      prevForYouPosts,
      prevNationalPosts,
      prevStatePosts,
      prevDistrictPosts;

    if (feedType === "public") {
      setPublicPosts((prev) => {
        prevPublicPosts = prev; // store
        return prev.filter(
          (item) => item.post?._id !== postId && item._id !== postId,
        );
      });
    }

    if (feedType === "prime") {
      setForYouPosts((prev) => {
        prevForYouPosts = prev;
        return prev.filter((p) => p._id !== postId);
      });

      setNationalPosts((prev) => {
        prevNationalPosts = prev;
        return prev.filter((p) => p._id !== postId);
      });

      setStatePosts((prev) => {
        prevStatePosts = prev;
        return prev.filter((p) => p._id !== postId);
      });

      setDistrictPosts((prev) => {
        prevDistrictPosts = prev;
        return prev.filter((p) => p._id !== postId);
      });
    }

    try {
      await feedApi.deletePost({ postId });
      toast.success("Post deleted successfully");
    } catch (error) {
      console.error("Delete failed", error);

      // ===== ROLLBACK =====
      if (feedType === "public" && prevPublicPosts) {
        setPublicPosts(prevPublicPosts);
      }

      if (feedType === "prime") {
        if (prevForYouPosts) setForYouPosts(prevForYouPosts);
        if (prevNationalPosts) setNationalPosts(prevNationalPosts);
        if (prevStatePosts) setStatePosts(prevStatePosts);
        if (prevDistrictPosts) setDistrictPosts(prevDistrictPosts);
      }

      toast.error("Failed to delete post");
    }
  };
  //======================= post edit and delete end =======================//

  ////////////////////////////////////////////////
  // data for trending topics
  const trendingTopics = [
    { title: "Aaj Tak news", percent: 177, tagRank: 1 },
    { title: "UP breaking news", percent: 142, tagRank: 2 },
    { title: "India Politics", percent: 98, tagRank: 3 },
    { title: "NEWS", percent: 65, tagRank: 4 },
    { title: "Programming", percent: 120, tagRank: 5 },
    { title: "React JS", percent: 210, tagRank: 6 },
    { title: "Laravel", percent: 155, tagRank: 7 },
    { title: "JavaScript", percent: 189, tagRank: 8 },
    { title: "Latest News", percent: 134, tagRank: 9 },
  ];

  // for showing limited trends or all (Toggle)
  const visibleTrends = showMoreTrends
    ? trendingTopics
    : trendingTopics.slice(0, 5);

  // for suggested creators
  const [suggestedCreators, setSuggestedCreators] = useState([]);
  const [suggestLoading, setSuggestLoading] = useState(false);

  // ============================== Follow Suggestions ================================
  // useEffect(() => {
  //   const fetchSuggestedUsers = async () => {
  //     setSuggestLoading(true);
  //     try {
  //       const res = await api.get("/follows/getSuggested");
  //       setSuggestedCreators(res.data.suggestions || []);
  //     } catch (err) {
  //       console.error("Suggested users error", err);
  //     } finally {
  //       setSuggestLoading(false);
  //     }
  //   };
  //   fetchSuggestedUsers();
  // }, []);

  // handle logout
  const handleLogout = () => {
    logout(); // remove JWT from storage
    navigate("/login", { replace: true }); // redirect to login
  };

  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////
  // REVOLUTION FUNCTION START
  const handleSupport = (revolutionId) => {
    setSignatureSubmitted(false);
    setSignatureData(false);
    setCommentInput("");
    setSupportStatus((prev) => ({
      ...prev,
      [revolutionId]: prev[revolutionId] === "support" ? null : "support",
    }));
  };

  const handleIgnore = (revolutionId) => {
    submitSupport("reject", revolutionId);
  };

  const handleSignatureSubmit = (signature) => {
    setSignatureData(signature);
    setSignatureSubmitted(true);
  };

  const submitSupport = async (action = "support", revolutionId) => {
    // confirmation for reject
    if (action === "reject") {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to reject this revolution? To support the revolution, go back to the post in the All Revolutions section.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#FF8A00",
      });

      if (!result.isConfirmed) return;
    }

    if (action === "support" && !signatureData) {
      toast.error("Please add signature.");
      return;
    }

    try {
      setSubmitting(true);

      let formData = new FormData();
      const actionType = action === "support" ? "support" : "reject";
      if (action === "support") {
        const response = await fetch(signatureData);
        const blob = await response.blob();

        formData.append("comment", commentInput);
        formData.append("digitalSignature", blob, "signature.png");
      }

      const res = await api.post(
        `/revolution/${revolutionId}/${actionType}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (action === "reject") {
        toast.success(
          res?.data?.message || "Revolution rejected successfully.",
        );
      }

      if (action === "support") {
        toast.success(
          res?.data?.message || "Revolution supported successfully.",
        );
      }

      setRevolutionData((prev) =>
        prev.map((revolution) =>
          revolution._id === revolutionId
            ? {
                ...revolution,
                userAction: action === "support" ? "SUPPORTED" : "REJECTED",
              }
            : revolution,
        ),
      );

      setSupportStatus((prev) => ({
        ...prev,
        [revolutionId]: action === "support" ? "supported" : "rejected",
      }));
      setTimeout(() => navigate("/revolution/support"), 1500);
    } catch (err) {
      const errorMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Failed to submit. Please try again.";
      toast.error(errorMsg);

      setSupportStatus((prev) => ({
        ...prev,
        [revolutionId]: null,
      }));
    } finally {
      setSubmitting(false);
      setCommentInput("");
      setSignatureSubmitted(false);
      // setSignatureData(false);
    }
  };

  // handle tabs click with cursor reset

  const handleTabs = (tabs) => {
    setActiveTab(tabs);

    if (tabs === "forYou") {
      // Reset for you pagination if needed
      if (forYouPosts.length === 0) {
        setPrimeCursor(null);
        setHasMorePrime(true);
        fetchPrimePosts(null, false);
      }
    }

    if (tabs === "national") {
      if (nationalPosts.length === 0) {
        setNationalCursor(null);
        setHasMoreNational(true);
        fetchNationalPosts(null, false);
      }
    }

    if (tabs === "state") {
      if (statePosts.length === 0) {
        setStateCursor(null);
        setHasMoreState(true);
        fetchStatePosts(null, false);
      }
    }

    if (tabs === "district") {
      if (districtPosts.length === 0) {
        setDistrictCursor(null);
        setHasMoreDistrict(true);
        fetchDistrictPosts(null, false);
      }
    }
  };

  const handleAll = async () => {
    handleTabs("forYou");
  };

  // REVOLUTION FUNCTION END
  ///////////////////////////////////////////////
  ///////////////////////////////////////////////

  // Block wrong URL immediately
  //======================= Block wrong URL immediately start =======================//
  if (!allowedTypes.includes(type)) {
    return <Navigate to="/404" replace />;
  }
  //======================= Block wrong URL immediately end =======================//

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        {/* ================= TOP HEADER NAVBAR ================= */}

        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />

        {/* ================= PRIME PUBLIC LAYOUT CONTAINER ================= */}
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {/* ================= LEFT SIDEBAR ================= */}
            {/* ===== LEFT SIDEBAR OVERLAY ===== */}
            {!showSidebar && (
              <div
                className="left-sidebar-overlay"
                onClick={() => setShowSidebar(true)}
              />
            )}

            {/* SIDEBAR COMPONENT */}
            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => {
                if (item.key === "public") {
                  handleTabs("forYou");
                }
                navigate(item.path);
              }}
              onLogout={handleLogout}
            />
            {/* LEFT SIDEBAR END */}

            {/* ================= CENTER AREA ================= */}
            <div
              className="col-lg-6 col-md-9 col-12 overflow-auto center-area-container"
              ref={feedScrollRef}
            >
              <div className="center-area">
                {/* ================= TOP PRIME AND PUBLIC FEED BUTTONS ================= */}
                <div className="prime-public-btn-box row g-3">
                  <div className="col-6 mb-3">
                    <button
                      className={`w-100 p-2 prime-btn shadow-sm ${
                        feedType === "prime" ? "active-feed-btn" : ""
                      }`}
                      onClick={() => navigate("/feed/prime")}
                    >
                      <FontAwesomeIcon icon={faStar} className="me-2" />
                      Prime
                    </button>
                  </div>

                  <div className="col-6 mb-3">
                    <button
                      className={`w-100 p-2 public-btn shadow-sm ${
                        feedType === "public" ? "active-feed-btn" : ""
                      }`}
                      onClick={() => {
                        navigate("/feed/public");
                        handleTabs("forYou");
                      }}
                    >
                      <FontAwesomeIcon icon={faUsers} className="me-2" />
                      Public
                    </button>
                  </div>
                </div>

                {/* ================= TABS ================= */}

                {feedType === "prime" && (
                  <div className="tab-section mb-3">
                    <button
                      className={
                        activeTab === "forYou" ? "tab active-tab" : "tab"
                      }
                      onClick={() => handleAll()}
                    >
                      For You
                    </button>

                    <button
                      className={
                        activeTab === "national" ? "tab active-tab" : "tab"
                      }
                      onClick={() => handleTabs("national")}
                    >
                      National
                    </button>

                    <button
                      className={
                        activeTab === "state" ? "tab active-tab" : "tab"
                      }
                      onClick={() => handleTabs("state")}
                    >
                      State
                    </button>

                    <button
                      className={
                        activeTab === "district" ? "tab active-tab" : "tab"
                      }
                      onClick={() => handleTabs("district")}
                    >
                      District
                    </button>
                  </div>
                )}

                {/* ================= CTEATE POST FORM ================= */}

                {/* PRIME FEED CREATE POST FORM */}
                {isProfileInfo?.role === "PRIME" && feedType === "prime" && (
                  <div className="create-post-card shadow-sm">
                    <div className="d-flex align-items-start gap-3">
                      <ProfileBadge
                        isBatch={isCheckBatch}
                        ProfileLink={profileLink}
                        profilePic={isProfileInfo?.profilePic}
                      />

                      <textarea
                        className="create-input"
                        placeholder="Write something here..."
                        value={postText}
                        onChange={(e) => setPostText(e.target.value)}
                        rows={3}
                      />
                    </div>

                    {/* IMAGE PREVIEW */}

                    {selectedImages.length > 0 && (
                      <div className="image-preview-box mt-2">
                        {selectedImages.map((img, index) => (
                          <div className="preview-image-wrapper" key={index}>
                            <img src={img.preview} className="preview-image" />
                            <span
                              className="remove-img"
                              onClick={() => removeImage(index)}
                            >
                              ×
                            </span>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* VIDEO PREVIEW */}

                    {selectedVideo && (
                      <div className="video-preview-box mt-2">
                        <div className="preview-video-wrapper">
                          <video
                            src={selectedVideo.preview}
                            controls
                            className="video-preview"
                          />
                          <span className="video-type-label">
                            {videoType === "short"
                              ? "🎬 Short Video"
                              : "🎥 Long Video"}
                          </span>

                          <span className="remove-video" onClick={removeVideo}>
                            ×
                          </span>
                        </div>
                      </div>
                    )}

                    <div className="create-footer mt-2">
                      <div className="create-icons">
                        {/* IMAGE ICON */}
                        <label className="">
                          <FontAwesomeIcon icon={faImage} />
                          <input
                            ref={imageInputRef}
                            type="file"
                            accept="image/*"
                            multiple
                            hidden
                            onChange={handleImageSelect}
                          />
                        </label>

                        <label className="">
                          <FontAwesomeIcon icon={faVideo} />
                          <input
                            ref={videoInputRef}
                            type="file"
                            accept="video/*"
                            hidden
                            onChange={handleVideoSelect}
                          />
                        </label>

                        <label className="">
                          <FontAwesomeIcon icon={faCirclePlay} />
                        </label>

                        <label className="">
                          <FontAwesomeIcon icon={faLocationDot} />
                        </label>

                        {/* monetization button */}
                          <div
                            className="form-check form-switch monetize-checkbox-container"
                            onClick={handleMonetizeClick}
                          >
                            <input
  className="form-check-input mt-0"
  type="checkbox"
  role="switch"
  id="monetization-checkbox"
  onChange={(e) => handleMonetizeToggle(e.target.checked)}
  disabled={
    Number(isProfileInfo?.monetizationLevel) < 2 || isMonetizeDisabled
  }
  checked={
    Number(isProfileInfo?.monetizationLevel) >= 2 && !isMonetizeDisabled
      ? isMonetized
      : false
  }
/>

                            <label
                              className={`form-check-label ${
                                Number(isProfileInfo?.monetizationLevel) < 2 || isMonetizeDisabled
                                  ? "text-muted"
                                  : ""
                              }`}
                              htmlFor="monetization-checkbox"
                            >
                              Monetize post
                              {/* Optional: Show limit status */}
                              {isMonetizeDisabled && (
                                <span className="text-danger ms-1" style={{ fontSize: "12px" }}>
                                  (Limit reached)
                                </span>
                              )}
                            </label>
                          </div>
                        {/* monetization button */}
                      </div>

                      <button
                        className="share-post-btn"
                        onClick={() =>
                          handlePostSubmit({ postFeedType: "PRIME" })
                        }
                        disabled={isUploading}
                      >
                        {isUploading ? "Posting..." : "Post"}
                      </button>
                    </div>
                  </div>
                )}

                {showPopup && <Popup onClose={() => setShowPopup(false)} />}

                {/* PUBLIC FEED CREATE POST FORM */}
                {isProfileInfo?.role === "PUBLIC" && feedType === "public" && (
                  <div className="create-post-card mt-2 shadow-sm">
                    <div className="d-flex align-items-start gap-3">
                      <ProfileBadge
                        isBatch={isCheckBatch}
                        ProfileLink={profileLink}
                        profilePic={isProfileInfo?.profilePic}
                      />

                      <textarea
                        className="create-input"
                        placeholder="Write something here..."
                        value={postText}
                        onChange={(e) => setPostText(e.target.value)}
                        rows={3}
                      />
                    </div>

                    {/* IMAGE PREVIEW */}
                    {selectedImages.length > 0 && (
                      <div className="image-preview-box mt-2">
                        {selectedImages.map((img, index) => (
                          <div className="preview-image-wrapper" key={index}>
                            <img src={img.preview} className="preview-image" />
                            <span
                              className="remove-img"
                              onClick={() => removeImage(index)}
                            >
                              ×
                            </span>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* VIDEO PREVIEW */}
                    {selectedVideo && (
                      <div className="video-preview-box mt-2">
                        <div className="preview-video-wrapper">
                          <video
                            src={selectedVideo.preview}
                            controls
                            className="video-preview"
                          />
                          <span className="video-type-label">
                            {videoType === "short"
                              ? "🎬 Short Video"
                              : "🎥 Long Video"}
                          </span>

                          <span className="remove-video" onClick={removeVideo}>
                            ×
                          </span>
                        </div>
                      </div>
                    )}

                    <div className="create-footer mt-2">
                      <div className="create-icons">
                        {/* IMAGE ICON */}
                        <label className="">
                          <FontAwesomeIcon icon={faImage} />
                          <input
                            ref={imageInputRef}
                            type="file"
                            accept="image/*"
                            multiple
                            hidden
                            onChange={handleImageSelect}
                          />
                        </label>

                        <label className="">
                          <FontAwesomeIcon icon={faVideo} />
                          <input
                            ref={videoInputRef}
                            type="file"
                            accept="video/*"
                            hidden
                            onChange={handleVideoSelect}
                          />
                        </label>

                        <label className="">
                          <FontAwesomeIcon icon={faCirclePlay} />
                        </label>

                        <label className="">
                          <FontAwesomeIcon icon={faLocationDot} />
                        </label>

                        {/* monetization button */}
                        <div
                          className="form-check form-switch monetize-checkbox-container"
                          onClick={handleMonetizeClick}
                        >
                          <input
  className="form-check-input mt-0"
  type="checkbox"
  role="switch"
  id="monetization-checkbox"
  onChange={(e) => handleMonetizeToggle(e.target.checked)}
  disabled={
    Number(isProfileInfo?.monetizationLevel) < 2 || isMonetizeDisabled
  }
  checked={
    Number(isProfileInfo?.monetizationLevel) >= 2 && !isMonetizeDisabled
      ? isMonetized
      : false
  }
/>

                          <label
                            className={`form-check-label ${
                              isProfileInfo?.monetizationLevel < 2
                                ? "text-muted"
                                : ""
                            }`}
                            htmlFor="monetization-checkbox"
                          >
                            Monetize post
                          </label>
                        </div>
                        {/* monetization button */}
                      </div>

                      <button
                        className="share-post-btn"
                        onClick={() =>
                          handlePostSubmit({ postFeedType: "PUBLIC" })
                        }
                        disabled={isUploading}
                      >
                        {isUploading ? "Posting..." : "Post"}
                      </button>
                    </div>
                  </div>
                )}

                {/* ================= FEED START ================= */}
                <div className="feed-section">
                  {/* ================= PRIME FEED ================= */}
                  {feedType === "prime" && (
                    <>
                      {activeTab === "forYou" && (
                        <>
                          {/* post upload progress bar */}
                          {isUploading && (
                            <div className="upload-progress my-2">
                              <div className="progress">
                                <div
                                  className="progress-bar progress-bar-striped progress-bar-animated custom-upload-bar"
                                  style={{ width: `${uploadProgress}%` }}
                                >
                                  {uploadProgress}%
                                </div>
                              </div>
                            </div>
                          )}

                          {/* skeleton loader */}
                          {loading &&
                            Array.from({ length: 4 }).map((_, index) => (
                              <PostSkeleton key={index} />
                            ))}

                          {/* No post Found Loading indicator */}
                          {!loading &&
                            forYouPosts.length === 0 &&
                            revolutionData.length === 0 && (
                              <p className="not-found-text text-center">
                                No posts found
                              </p>
                            )}

                          {/* =========== UPDATED: PRIME PAGE DATA WITH REVOLUTIONS + POSTS + LIVE CHANNELS ========== */}
                          {!loading &&
                            (() => {
                              const channels = flattenedChannels;
                              const allItems = [];
                              let channelIndex = 0;
                              let contentCount = 0;

                              const pushChannel = () => {
                                if (channels.length > 0) {
                                  allItems.push(
                                    <LiveChannelCard
                                      key={`channel-${contentCount}`}
                                      channel={
                                        channels[channelIndex % channels.length]
                                      }
                                    />,
                                  );
                                  channelIndex++;
                                }
                              };

                              // First, add all revolution cards
                              revolutionData.forEach((revolution) => {
                                allItems.push(
                                  <RevolutionDetailsCard
                                    key={`rev-${revolution._id}`}
                                    revolution={revolution}
                                    currentUserId={currentUserId}
                                    userAction="NONE"
                                    supportStatus={supportStatus}
                                    commentInput={commentInput}
                                    setCommentInput={setCommentInput}
                                    submitting={submitting}
                                    signatureSubmitted={signatureSubmitted}
                                    handleSupport={handleSupport}
                                    handleIgnore={handleIgnore}
                                    handleSignatureSubmit={
                                      handleSignatureSubmit
                                    }
                                    submitSupport={submitSupport}
                                    setSignatureData={setSignatureData}
                                    handlers={{
                                      openImage: (imgs) => {
                                        setActiveImages(imgs);
                                        setShowImageModal(true);
                                      },
                                      onShare: handleShareClick,
                                      onVideoPlay: handleVideoPlay,
                                    }}
                                  />,
                                );

                                contentCount++;
                                if (contentCount % 5 === 0) {
                                  pushChannel();
                                }
                              });

                              // Then add all posts
                              for (let i = 0; i < forYouPosts.length; i++) {
                                const post = forYouPosts[i];

                                allItems.push(
                                  <PostCard
                                    key={`post-${post._id}`}
                                    post={post}
                                    currentUserId={currentUserId}
                                    BASE_URL={BASE_URL}
                                    followLoading={followLoading}
                                    isPublic={false}
                                    feedType="PRIME"
                                    onReport={report.openReport}
                                    hideFollowButton={isPrimeUser}
                                    currentUserRole={isProfileInfo?.role}
                                    handlers={{
                                      onEdit: handleEditPost,
                                      onDelete: handleDeletePost,
                                      onLike: handleLikeToggle,
                                      onSave: handleSaveToggle,
                                      onShare: handleShareClick,
                                      openImage: (imgs) => {
                                        setActiveImages(imgs);
                                        setShowImageModal(true);
                                      },
                                      onVideoPlay: handleVideoPlay2,
                                      onFollowToggle: handleFollowToggle,
                                      onComment: openComments,
                                      videoRefs,
                                    }}
                                  />,
                                );

                                contentCount++;
                                if (contentCount % 5 === 0) {
                                  pushChannel();
                                }
                              }

                              // // ✅ ADD REMAINING CHANNELS AT THE END
                              // // channelIndex tells us how many channels were used during the feed
                              // // remaining = total channels - channels already shown
                              // const usedCount =
                              //   channelIndex % channels.length ||
                              //   (channelIndex > 0 &&
                              //   channelIndex % channels.length === 0
                              //     ? 0
                              //     : channelIndex % channels.length);

                              // const remainingChannels = channels.slice(
                              //   channelIndex % channels.length === 0
                              //     ? 0 // all channels were used evenly, show all again? No — track differently
                              //     : channelIndex % channels.length,
                              // );

                              // // Simpler approach — track which index we stopped at
                              // if (channels.length > 0) {
                              //   const stoppedAt =
                              //     channelIndex % channels.length;

                              //   // If stoppedAt is 0, it means all channels were used evenly — no remaining
                              //   // If stoppedAt > 0, show channels from stoppedAt to end
                              //   if (stoppedAt > 0) {
                              //     channels
                              //       .slice(stoppedAt)
                              //       .forEach((channel, idx) => {
                              //         allItems.push(
                              //           <LiveChannelCard
                              //             key={`remaining-channel-${idx}`}
                              //             channel={channel}
                              //           />,
                              //         );
                              //       });
                              //   }
                              // }

                              return allItems;
                            })()}

                          {/* Infinite scroll loader */}
                          {loadingPrimeMore && (
                            <div className="not-found-text text-center my-3">
                              <div
                                className="reply-loading spinner-border text-secondary text-center"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          )}

                          {/* End message */}
                          {!hasMorePrime && forYouPosts.length > 0 && (
                            <p className="text-center text-muted mb-2">
                              No more posts
                            </p>
                          )}
                        </>
                      )}

                      {activeTab === "national" && (
                        <>
                          {loadingNational && nationalPosts.length === 0 ? (
                            Array.from({ length: 3 }).map((_, index) => (
                              <PostSkeleton key={index} />
                            ))
                          ) : nationalPosts.length === 0 ? (
                            <p className="text-center mt-4">
                              No posts available
                            </p>
                          ) : (
                            nationalPosts.map((post) => (
                              <PostCard
                                key={post._id}
                                post={post}
                                currentUserId={currentUserId}
                                BASE_URL={BASE_URL}
                                followLoading={followLoading}
                                isPublic={false}
                                feedType="PRIME"
                                onReport={report.openReport}
                                hideFollowButton={isPrimeUser}
                                currentUserRole={isProfileInfo?.role}
                                handlers={{
                                  onEdit: handleEditPost,
                                  onDelete: handleDeletePost,
                                  onLike: handleLikeToggle,
                                  onSave: handleSaveToggle,
                                  onShare: handleShareClick,
                                  openImage: (imgs) => {
                                    setActiveImages(imgs);
                                    setShowImageModal(true);
                                  },
                                  onVideoPlay: handleVideoPlay2,
                                  onFollowToggle: handleFollowToggle,
                                  onComment: openComments,
                                  videoRefs,
                                }}
                              />
                            ))
                          )}
                          {loadingNational && nationalPosts.length > 0 && (
                            <div className="text-center my-3">
                              <div
                                className="spinner-border text-secondary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          )}
                          {!hasMoreNational && nationalPosts.length > 0 && (
                            <p className="text-center text-muted mb-2">
                              No more posts
                            </p>
                          )}
                        </>
                      )}

                      {activeTab === "state" && (
                        <>
                          {loadingState && statePosts.length === 0 ? (
                            Array.from({ length: 3 }).map((_, index) => (
                              <PostSkeleton key={index} />
                            ))
                          ) : statePosts.length === 0 ? (
                            <p className="text-center mt-4">
                              No posts available
                            </p>
                          ) : (
                            statePosts.map((post) => (
                              <PostCard
                                key={post._id}
                                post={post}
                                currentUserId={currentUserId}
                                BASE_URL={BASE_URL}
                                followLoading={followLoading}
                                isPublic={false}
                                feedType="PRIME"
                                onReport={report.openReport}
                                hideFollowButton={isPrimeUser}
                                currentUserRole={isProfileInfo?.role}
                                handlers={{
                                  onEdit: handleEditPost,
                                  onDelete: handleDeletePost,
                                  onLike: handleLikeToggle,
                                  onSave: handleSaveToggle,
                                  onShare: handleShareClick,
                                  openImage: (imgs) => {
                                    setActiveImages(imgs);
                                    setShowImageModal(true);
                                  },
                                  onVideoPlay: handleVideoPlay2,
                                  onFollowToggle: handleFollowToggle,
                                  onComment: openComments,
                                  videoRefs,
                                }}
                              />
                            ))
                          )}
                          {loadingState && statePosts.length > 0 && (
                            <div className="text-center my-3">
                              <div
                                className="spinner-border text-secondary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          )}
                          {!hasMoreState && statePosts.length > 0 && (
                            <p className="text-center text-muted mb-2">
                              No more posts
                            </p>
                          )}
                        </>
                      )}

                      {activeTab === "district" && (
                        <>
                          {loadingDistrict && districtPosts.length === 0 ? (
                            Array.from({ length: 3 }).map((_, index) => (
                              <PostSkeleton key={index} />
                            ))
                          ) : districtPosts.length === 0 ? (
                            <p className="text-center mt-4">
                              No posts available
                            </p>
                          ) : (
                            districtPosts.map((post) => (
                              <PostCard
                                key={post._id}
                                post={post}
                                currentUserId={currentUserId}
                                BASE_URL={BASE_URL}
                                followLoading={followLoading}
                                isPublic={false}
                                feedType="PRIME"
                                onReport={report.openReport}
                                hideFollowButton={isPrimeUser}
                                currentUserRole={isProfileInfo?.role}
                                handlers={{
                                  onEdit: handleEditPost,
                                  onDelete: handleDeletePost,
                                  onLike: handleLikeToggle,
                                  onSave: handleSaveToggle,
                                  onShare: handleShareClick,
                                  openImage: (imgs) => {
                                    setActiveImages(imgs);
                                    setShowImageModal(true);
                                  },
                                  onVideoPlay: handleVideoPlay2,
                                  onFollowToggle: handleFollowToggle,
                                  onComment: openComments,
                                  videoRefs,
                                }}
                              />
                            ))
                          )}
                          {loadingDistrict && districtPosts.length > 0 && (
                            <div className="text-center my-3">
                              <div
                                className="spinner-border text-secondary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          )}
                          {!hasMoreDistrict && districtPosts.length > 0 && (
                            <p className="text-center text-muted mb-2">
                              No more posts
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {/* ================= PUBLIC FEED ================= */}
                  {feedType === "public" && (
                    <>
                      {activeTab === "forYou" && (
                        <>
                          {/* post upload progress bar */}
                          {isUploading && (
                            <div className="upload-progress my-2">
                              <div className="progress">
                                <div
                                  className="progress-bar progress-bar-striped progress-bar-animated custom-upload-bar"
                                  style={{ width: `${uploadProgress}%` }}
                                >
                                  {uploadProgress}%
                                </div>
                              </div>
                            </div>
                          )}

                          {/* skeleton loader */}
                          {loading &&
                            Array.from({ length: 4 }).map((_, index) => (
                              <PostSkeleton key={index} />
                            ))}

                          {/* No post Found Loading indicator */}
                          {!loading && publicPosts.length === 0 && (
                            <p className="not-found-text text-center">
                              No posts found
                            </p>
                          )}

                          {/* Public Feed */}
                          {!loading &&
                            publicPosts.map((item) => {
                              const normalizedPost =
                                item.type === "REPOST"
                                  ? {
                                      ...item,
                                      isRepost: true,
                                      originalPost: item.post,
                                      repostedBy: item.repostedBy,
                                      repostedAt: item.createdAt,
                                      _id: item._id,
                                    }
                                  : {
                                      ...item.post,
                                      isRepost: false,
                                    };

                              return (
                                <PostCard
                                  key={
                                    item.type === "REPOST"
                                      ? item.post._id + item.createdAt
                                      : item.post._id
                                  }
                                  post={normalizedPost}
                                  currentUserId={currentUserId}
                                  BASE_URL={BASE_URL}
                                  followLoading={followLoading}
                                  isPublic={true}
                                  feedType="PUBLIC"
                                  onReport={report.openReport}
                                  hideFollowButton={isPrimeUser}
                                  currentUserRole={isProfileInfo?.role}
                                  handlers={{
                                    onEdit: handleEditPost,
                                    onDelete: handleDeletePost,
                                    onLike: handleLikeToggle,
                                    onSave: handleSaveToggle,
                                    onShare: handleShareClick,
                                    openImage: (imgs) => {
                                      setActiveImages(imgs);
                                      setShowImageModal(true);
                                    },
                                    onVideoPlay: handleVideoPlay,
                                    onFollowToggle: handleFollowToggle,
                                    onComment: openComments,
                                    videoRefs,
                                  }}
                                />
                              );
                            })}

                          {/* Infinite scroll loader */}
                          {loadingMore && (
                            <div className="not-found-text text-center my-3">
                              <div
                                className="reply-loading spinner-border text-secondary text-center"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          )}

                          {/* End message */}
                          {!hasMorePublic && publicPosts.length > 0 && (
                            <p className="text-center text-muted mb-2 align-self-center">
                              No more posts
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {/* ================= FEED END ================= */}
              </div>
            </div>

            {/* ================= RIGHT SIDEBAR ================= */}
            <div className="col-lg-3 d-none d-lg-block">
              <div className="sidebar-right">
                <aside className="trending-box card mb-3">
                  <p className="trending-title">
                    <span className="trending-up-icon me-1">
                      <Icon icon="ic:round-trending-up" />
                    </span>
                    Trending Topics
                  </p>

                  <ul className="trend-list">
                    {visibleTrends.map((topic, index) => (
                      <li key={index}>
                        <span>#{topic.tagRank}</span>#{topic.title}
                        <span className="trending-badge badge rounded-pill">
                          +{topic.percent}%
                        </span>
                      </li>
                    ))}
                  </ul>

                  {/* SEE MORE BUTTON */}
                  <p
                    className="see-more-btn text-center mt-2 mb-0"
                    onClick={() => setShowMoreTrends(!showMoreTrends)}
                  >
                    {showMoreTrends ? "See Less" : "See More"}
                  </p>
                </aside>

                <aside className="trending-box card mb-3">
                  <p className="trending-title">
                    <span className="me-1">
                      <FontAwesomeIcon icon={faUserGroup} />
                    </span>{" "}
                    Follow Suggestions
                  </p>
                  <ul className="suggested-creators-list">
                    {suggestLoading ? (
                      <p
                        className="text-center text-muted"
                        style={{ fontSize: "13px" }}
                      >
                        Loading...
                      </p>
                    ) : suggestedCreators.length === 0 ? (
                      <p
                        className="text-center text-muted"
                        style={{ fontSize: "13px" }}
                      >
                        No suggestions
                      </p>
                    ) : (
                      suggestedCreators.map((creator) => (
                        <li key={creator._id}>
                          <div className="post-header">
                            {/* PROFILE PIC */}
                            {/* <img
                              src={creator.profilePic || "https://via.placeholder.com/40"}
                              className="user-img"
                              alt={creator.fullName}
                              onError={(e) => {
                                e.target.src = "https://via.placeholder.com/40";
                              }}
                            /> */}

                            <img
                              src={creator?.profilePic || userProfile}
                              className="user-img"
                              alt={creator?.fullName || "User"}
                              onError={(e) => {
                                e.target.onerror = null; // prevent infinite loop
                                e.target.src = userProfile;
                              }}
                            />

                            <div>
                              {/* FULL NAME + BADGE */}
                              <p className="username">
                                {creator.fullName}
                                {creator.isBatch && (
                                  <span className="feed-verified-badge-success ms-1">
                                    {" "}
                                    {/* ← changed */}
                                    <Icon icon="ic:baseline-verified" />
                                  </span>
                                )}
                              </p>

                              {/* MUTUAL CONNECTIONS */}
                              <p className="group-name">
                                {creator.mutualConnections > 0
                                  ? `${creator.mutualConnections} mutual connection${creator.mutualConnections > 1 ? "s" : ""}`
                                  : creator.role}
                              </p>
                            </div>
                          </div>
                        </li>
                      ))
                    )}
                  </ul>
                </aside>
              </div>
            </div>
          </div>
        </div>

        {/* =========== IMAGE MODAL START =========== */}
        {showImageModal && (
          <div className="image-modal">
            <span
              className="close-modal"
              onClick={() => setShowImageModal(false)}
            >
              ×
            </span>

            <Swiper
              modules={[Navigation, Pagination, Keyboard]}
              navigation
              pagination={{ clickable: true }}
              keyboard={{ enabled: true }}
              spaceBetween={20}
              slidesPerView={1}
              className="image-swiper"
            >
              {activeImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <TransformWrapper
                    pinch={{ disabled: false }}
                    doubleClick={{ disabled: false }}
                    wheel={{ step: 0.1 }}
                  >
                    <TransformComponent>
                      <img
                        src={`${img.replace(/\\/g, "/")}`}
                        className="modal-image"
                        alt="post"
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
        {/* =========== IMAGE MODAL END =========== */}

        {/* =========== POST EDIT MODAL START =========== */}
        {showEditModal && (
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content shadow-lg post-edit-modal-container">
                {/* HEADER */}
                <div className="modal-header">
                  <h5 className="modal-title">Edit Post</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowEditModal(false)}
                  />
                </div>

                {/* BODY */}
                <div className="modal-body">
                  {/* TEXT */}
                  <textarea
                    className="form-control mb-3"
                    rows={3}
                    value={editText}
                    onChange={(e) => setEditText(e.target.value)}
                    placeholder="Edit your post..."
                  />

                  {/* IMAGE PREVIEW */}
                  {editImages.length > 0 && (
                    <div className="image-preview-box">
                      {editImages.map((img, i) => (
                        <div key={i} className="preview-image-wrapper">
                          <img src={img.preview} className="preview-image" />
                          <span
                            className="remove-img"
                            onClick={() => handleRemoveEditImage(i)}
                          >
                            ×
                          </span>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* VIDEO PREVIEW */}
                  {editVideo && (
                    <div className="video-preview-box">
                      <div className="preview-video-wrapper">
                        <video
                          src={editVideo.preview}
                          controls
                          className="video-preview"
                        />
                        <span className="video-type-label">
                          {editVideoType === "short"
                            ? "🎬 Short Video"
                            : "🎥 Long Video"}
                        </span>
                        <span
                          className="remove-video"
                          onClick={handleRemoveEditVideo}
                        >
                          ×
                        </span>
                      </div>
                    </div>
                  )}

                  {/* MEDIA BUTTONS */}
                  <div className="d-flex gap-3 mt-3">
                    <label>
                      <FontAwesomeIcon icon={faImage} />
                      <input
                        ref={editImageInputRef}
                        type="file"
                        multiple
                        accept="image/*"
                        hidden
                        onChange={handleEditImageSelect}
                      />
                    </label>

                    <label>
                      <FontAwesomeIcon icon={faVideo} />
                      <input
                        ref={editVideoInputRef}
                        type="file"
                        accept="video/*"
                        hidden
                        onChange={handleEditVideoSelect}
                      />
                    </label>
                  </div>
                </div>

                {/* FOOTER */}
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowEditModal(false)}
                    disabled={isUpdating}
                  >
                    Cancel
                  </button>

                  <button
                    className=" btn upload-btn"
                    onClick={handleUpdatePost}
                    disabled={isUpdating}
                  >
                    {isUpdating ? "Updating..." : "Update Post"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* =========== POST EDIT MODAL END =========== */}

        {/* =========== COMMENT MODAL START =========== */}
        <CommentModal
          show={showCommentModal}
          onClose={() => {
            setShowCommentModal(false);
            setReplyTo(null);
          }}
          comments={comments}
          commentLoading={commentLoading}
          loadingMoreComments={loadingMoreComments}
          hasMoreComments={hasMoreComments}
          onLoadMoreComments={loadMoreComments}
          totalCommentsCount={totalCommentsCount}
          BASE_URL={BASE_URL}
          currentUserId={currentUserId}
          postOwnerId={postOwnerId}
          commentText={commentText}
          setCommentText={setCommentText}
          replyText={replyText}
          setReplyText={setReplyText}
          replyTo={replyTo}
          setReplyTo={setReplyTo}
          onAddComment={handleAddComment}
          onAddReply={handleAddReply}
          onLikeComment={handleCommentLike}
          onFetchReplies={fetchReplies}
          onDelete={handleDeleteComment}
          repliesMap={repliesMap}
          loadingReplies={loadingReplies}
          activeMenuId={activeMenuId}
          setActiveMenuId={setActiveMenuId}
          showDeleteConfirm={showDeleteConfirm}
          setShowDeleteConfirm={setShowDeleteConfirm}
          deleteType={deleteType}
          setDeleteTargetId={setDeleteTargetId}
          setDeleteType={setDeleteType}
          setParentCommentId={setParentCommentId}
          onReport={report.openReport}
        />
        {/* =========== COMMENT MODAL END =========== */}

        {/* =========== MESSAGE DRAWER START =========== */}
        {/* Msg Drawer */}
        {showMsgDrawer && (
          <>
            <div
              className="msg-overlay"
              onClick={() => setShowMsgDrawer(false)}
            ></div>

            <div className="msg-drawer">
              <div className="msg-header">
                <h3>Chats</h3>
                <span onClick={() => setShowMsgDrawer(false)}>✕</span>
              </div>

              <div className="msg-search">
                <input placeholder="Search Messenger" />
              </div>

              <div className="msg-tabs">
                <span className="active">All</span>
                <span>Unread</span>
                <span>Groups</span>
                <span>Communities</span>
              </div>

              <div className="msg-empty">
                <h4>No chats</h4>
                <p>When you have chats, you'll see them here.</p>
              </div>

              <div
                className="msg-footer"
                onClick={() => {
                  setShowMsgDrawer(false);
                  navigate("/message");
                }}
              >
                See all in Messenger
              </div>
            </div>
          </>
        )}
        {/* =========== MESSAGE DRAWER END =========== */}

        {/* =========== SHARE MODAL START =========== */}
        <ShareModal
          post={sharePost}
          isPrime={feedType === "prime" && sharePost?.feedType !== "REVOLUTION"}
          isRevolution={sharePost?.feedType === "REVOLUTION"}
          onClose={() => setSharePost(null)}
          onInternalShare={handleInternalShare}
          onExternalShare={handleExternalShare}
          onRepost={handleRepost}
        />
        {/* =========== SHARE MODAL END =========== */}

        {/* =========== REPORT MODAL END =========== */}
        <ReportModal
          show={report.showModal}
          step={report.step}
          reason={report.reason}
          subReason={report.subReason}
          setReason={report.setReason}
          setSubReason={report.setSubReason}
          onNext={() => report.setStep(2)}
          onBack={() => {
            report.setSubReason(null);
            report.setStep(1);
          }}
          onSubmit={report.submitReport}
          loading={report.loading}
          onClose={() => report.setShowModal(false)}
        />
        {/* =========== REPORT MODAL END =========== */}
      </div>
    </div>
  );
}

export default Feed;